import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Typography, Grid, Box, Card, useTheme, Avatar } from '@material-ui/core';
import AttachmentIcon from '@material-ui/icons/Attachment';
import { IdeaCss } from '../IdeaCss';
import { ImagineLinkify } from '../../TextLinkify';
import { AttachmentFiles } from '../AttachmentFiles';
import { AttachmentVideo } from '../AttachmentVideo';
import { AttachmentImages } from '../AttachmentImages';

export function IdeaAttachments() {
  const theme = useTheme();
  const classes = IdeaCss();
  const { t } = useTranslation();
  const { ideaDetailsFlux } = useSelector(state => state.fluxIdeas);

  return (
    <Grid item xs={12}>
      <Card elevation={0} className={classes.card}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box display="flex" alignItems="center">
              <Avatar className={classes.avatarIcon}>
                <AttachmentIcon color="primary" fontSize="small" />
              </Avatar>
              <Typography variant="subtitle1">{t('anexos')}</Typography>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Typography
              variant="body2"
              style={{ fontWeight: 500, color: theme.palette.auxiliary.indigo.main }}
            >
              {ideaDetailsFlux.links?.length > 0 && <ImagineLinkify>{ideaDetailsFlux.links}</ImagineLinkify>}
            </Typography>
            {ideaDetailsFlux.attachments?.length > 0 && (
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <AttachmentFiles attachments={ideaDetailsFlux?.attachments} />
                </Grid>
                <Grid item xs={12}>
                  <AttachmentVideo attachments={ideaDetailsFlux?.attachments} />
                </Grid>
                <Grid item xs={12}>
                  <AttachmentImages attachments={ideaDetailsFlux?.attachments} />
                </Grid>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Card>
    </Grid>
  );
}
